'use client';

import AuthGuard from '@/src/components/AuthGuard';
import { ApiProvider } from '@/src/providers/Api';
import type { ReactNode } from 'react';
import { HomeMeProvider } from '@/src/providers/Me';
import { SessionProvider } from '@/src/providers/Session';

export default function NoTenantLayout({ children }: { children: ReactNode }) {
  return (
    <ApiProvider>
      <SessionProvider>
        <HomeMeProvider>
          <AuthGuard layout="home">{children}</AuthGuard>
        </HomeMeProvider>
      </SessionProvider>
    </ApiProvider>
  );
}
